import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';

export default class Tree extends Phaser.GameObjects.Image {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene, 0, 0, ABCyaPhaser.Images.DEFAULT_ATLAS, UIAssetKeys._Tree_1);
    this.setOrigin(0);
    this.speed = 0;
    this.destX = 0;
  }

  reset (startX, startY, destX, speed) {
    const n = Phaser.Math.Between(1,3);
    this.setFrame(`Tree_${n}`).setOrigin(0);
    this.x = startX;
    this.y = startY;
    this.speed = -speed;
    this.destX = destX;
  }

  tick(dt) {
    this.x += this.speed * dt;
  }
}